import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-link-cards',
  templateUrl: './link-cards.component.html',
  styleUrls: ['./link-cards.component.css']
})
export class LinkCardsComponent implements OnInit {

  @Input() image;
  @Input() text;
  @Input() link;
  @Output() scrollAction = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }

  scroll(data) {
  
    this.scrollAction.emit(data);
  }

}
